module.exports = __webpack_public_path__ + "static/media/senya.5a548e79.png";